const pickerModifiers = [
  {
    name: "flip",
    enabled: !0,
    options: {
      // Try only the opposite side – keeps the logic simple
      fallbackPlacements: ["top-start", "top-end"],
      boundary: "viewport",
      // or 'clippingParents' (default)
      padding: 4,
      // extra breathing-room before flipping
      // `flipVariations` is true by default, but we’ll be explicit:
      flipVariations: !0
    }
  },
  {
    name: "preventOverflow",
    enabled: !0,
    options: {
      altAxis: !0,
      // allow vertical shifting
      tether: !0,
      // keep popper “attached” to the anchor
      rootBoundary: "viewport",
      padding: 4
    }
  }
], getPopperModifierOffset = ({
  top,
  bottom
}) => ({
  name: "offset",
  options: {
    offset: ({ placement }) => placement.startsWith("bottom") ? [0, bottom] : placement.startsWith("top") ? [0, top] : [0, 0]
  }
});
export {
  getPopperModifierOffset,
  pickerModifiers
};
//# sourceMappingURL=popperModifiers.js.map
